'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('slick-carousel');

function _interopRequireDefault(obj) {
	return obj && obj.__esModule ? obj : { default: obj };
}

//sliders
var $sliderFeaturedProducts = (0, _jquery2.default)('.slider-featured-products');
var $sliderHeader = (0, _jquery2.default)('.slider-section-carousel');
var $sliderInstagram = (0, _jquery2.default)('.slider-instagram');
var $sliderBase = (0, _jquery2.default)('.js-slider-base');

if ($sliderFeaturedProducts.length) {
	$sliderFeaturedProducts.slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		dots: true,
		arrows: true,
		infinite: true,
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 1
			}
		}]
	});
}

if ($sliderHeader.length) {
	$sliderHeader.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: false,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 3000,
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 1
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 1
			}
		}]
	});
}

if ($sliderInstagram.length) {
	$sliderInstagram.slick({
		slidesToShow: 4,
		slidesToScroll: 1,
		dots: true,
		arrows: true,
		infinite: true
	});
}

if ($sliderBase.length) {
	$sliderBase.slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: true,
		infinite: true,
		fade: true,
		cssEase: 'linear'
	});
}